import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { UserIdleService } from 'angular-user-idle';

import { Observable, of } from 'rxjs';

import { sharedConstants } from '../shared-constants';
import * as UrlService from './url.service';

import { TimeoutDialog } from '../components/dialogs/timeout-dialog/timeout-dialog.component';

import { environment } from '../../../environments/environment';

@Injectable()
export class AuthManagerService {
  private controllerName: string = "authentication";

  private isAuthenticated: boolean = null;
  private isAuthenticatedRetrieving: Observable<boolean> = null;
  private timeoutDialog: MatDialogRef<TimeoutDialog, string> = null;
  private timeoutData: any = null;
  

  constructor(
    private apiClient: UrlService.UrlService,
    private userIdle: UserIdleService,
    private router: Router,
    private dialog: MatDialog
  ) {
  }

  private timeout(redirect: boolean): void {
    this.userIdle.stopWatching();
    this.userIdle.stopTimer();
    this.timeoutDialog = null;
    this.timeoutData = null;

    this.logOut().subscribe(() => {
      if (
        !this.router.url.toLocaleLowerCase().startsWith("/manuallogin") &&
        !this.router.url.toLocaleLowerCase().startsWith("/sessionexpired") &&
        redirect
      ) {
        this.router.navigateByUrl('/sessionexpired?returnUrl=' + encodeURIComponent(this.router.url));
      }
    }, () => {
      alert('Failed to log out');
      if (
        !this.router.url.toLocaleLowerCase().startsWith("/manuallogin") &&
        !this.router.url.toLocaleLowerCase().startsWith("/sessionexpired") &&
        redirect
      ) {
        this.router.navigateByUrl('/sessionexpired?returnUrl=' + encodeURIComponent(this.router.url));
      }
    });
  }

  public getIsAuthenticated(): Observable<boolean> {
    if (this.isAuthenticated === null) {
      if (this.isAuthenticatedRetrieving === null) {
        this.isAuthenticatedRetrieving = this.fetchIsAuthenticated();

        this.isAuthenticatedRetrieving.subscribe(result => {
          setInterval(() => {
              this.fetchIsAuthenticated()
                .subscribe(result => {
                  if (!result) {
                    this.timeout(true);
                  }
                });
            },
            environment.ping);

          if (!result) {
            this.timeout(false);
          } else {
            this.startIdleCheck();
          }
        });
      }

      return this.isAuthenticatedRetrieving;
    }

    return of(this.isAuthenticated);
  }

  private isSubscribed: boolean = false;
  private startIdleCheck() {
    this.userIdle.startWatching();

    if (!this.isSubscribed) {
      this.isSubscribed = true;

      this.userIdle.onTimerStart().subscribe(count => {
        if (this.isAuthenticated && count) {
          if (this.timeoutDialog == null) {
            this.timeoutData = {
              count: count
            };
            this.timeoutDialog = this.dialog.open(TimeoutDialog, {
              width: '350px',
              data: this.timeoutData
            });

            this.timeoutDialog.afterClosed().subscribe(result => {
              if (result !== 'true') {
                this.timeout(true);
              } else {
                this.userIdle.stopTimer();
                this.userIdle.resetTimer();
                this.userIdle.startWatching();
                this.timeoutDialog = null;
                this.timeoutData = null;
              }
            });
          }

          this.timeoutData.count = environment.timeout - count;
        }
      });

      this.userIdle.onTimeout().subscribe(() => {
        if(this.timeoutDialog != null)
          this.timeoutDialog.close('false');
      });
    }
  }

  private fetchIsAuthenticated(): Observable<boolean> {
    this.isAuthenticatedRetrieving = this.apiClient.get<boolean>(sharedConstants.appName, this.controllerName, "isauthenticated",null, null);

    this.isAuthenticatedRetrieving.subscribe(item => {
      //Clear Observable
      this.isAuthenticatedRetrieving = null;

      //Set Value
      this.isAuthenticated = item;
    });

    return this.isAuthenticatedRetrieving;
  }

  public logIn(userName: string, password: string): Observable<LogInResponse> {
    var obs: Observable<LogInResponse> = this.apiClient.post<LogInResponse>(sharedConstants.appName, this.controllerName, "login",
      {
        UserName: userName,
        Password: password
      }, null);

    obs.subscribe((response: LogInResponse) => {
      if (response.successful) {
        this.isAuthenticated = true;
        this.startIdleCheck();
      }
    });

    return obs;
  }

  public logOut(): Observable<any> {
    var obs: Observable<Object> = this.apiClient.get(sharedConstants.appName, this.controllerName, "logout", null, null);

    return obs;
  }
}

export class LogInResponse {
  public successful: boolean;
  public message: string;
}
